import { useState, useEffect } from 'react';
import { Modal, Form, Spinner } from 'react-bootstrap';
import { useListIPsQuery, useAddIPMutation, useDeleteIPMutation } from '../../app/userApi/userApi';
import Button from '../../components/shared/buttons/button';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { showToast } from '../../helpers/Utils';
import './IgnoreIPs.css';

const IgnoreIPs = () => {
  const { data: ipsData, isLoading } = useListIPsQuery();
  const [addIP, { isLoading: isAdding }] = useAddIPMutation();
  const [deleteIP, { isLoading: isDeleting }] = useDeleteIPMutation();

  const [ips, setIps] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newIP, setNewIP] = useState('');
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    if (ipsData?.data) {
      setIps(ipsData.data);
    }
  }, [ipsData]);

  const validateIP = (ip) => {
    const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
    if (!ipRegex.test(ip)) {
      return 'Invalid IP format. Use format: xxx.xxx.xxx.xxx';
    }
    const parts = ip.split('.');
    for (let part of parts) {
      const num = parseInt(part, 10);
      if (num < 0 || num > 255) {
        return 'Each IP segment must be between 0 and 255';
      }
    }
    return '';
  };

  const handleOpenModal = () => {
    setNewIP('');
    setValidationError('');
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setNewIP('');
    setValidationError('');
  };

  const handleAddIP = async () => {
    if (!newIP.trim()) {
      setValidationError('Please enter an IP address');
      return;
    }

    const error = validateIP(newIP.trim());
    if (error) {
      setValidationError(error);
      return;
    }

    try {
      await addIP({ ip: newIP.trim() }).unwrap();
      handleClose();
    } catch (error) {
      console.error('Failed to add IP:', error);
    }
  };

  const handleDeleteIP = async (id) => {
  
      try {
        await deleteIP(id).unwrap();
      } catch (error) {
        console.error('Failed to delete IP:', error);
        // showToast('Failed to delete IP', 'error');
      }
    
  };

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center p-4">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div className="ignore-ips-container">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Ignore IP Addresses</h4>
        <Button
          label="Add IP"
          icon={<FaPlus />}
          onClick={handleOpenModal}
        />
      </div>

      <div className="ips-list">
        {ips.map((item, index) => (
          <div key={item._id || index} className="ip-item">
            <span className="ip-address">{item.ip}</span>
            <button
              className="action-btn delete"
              onClick={() => handleDeleteIP(item._id)}
              disabled={isDeleting}
              type="button"
            >
              <FaTrash />
            </button>
          </div>
        ))}

        {ips.length === 0 && (
          <div className="no-ips">No IP addresses in ignore list</div>
        )}
      </div>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add IP Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>IP Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="e.g. 192.168.1.1"
              value={newIP}
              onChange={(e) => {
                setNewIP(e.target.value);
                if (validationError) setValidationError('');
              }}
              className={validationError ? 'is-invalid' : ''}
              isInvalid={!!validationError}
            />
            {validationError && (
              <Form.Control.Feedback type="invalid" className="d-block">
                {validationError}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button label="Cancel" className="borderedBtn" onClick={handleClose} />
          <Button
            label={isAdding ? 'Adding...' : 'Add IP'}
            onClick={handleAddIP}
            disabled={isAdding}
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default IgnoreIPs;
